import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SIH, useChartsData } from '../../../../Common/hooks/useChartsData';


export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children , module }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIH.MANAGEMENT,
            url: 'governanceroom/dashboard/sihsus/aih/managementValues'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value
        }
    );

    const chartData = data
        ? {
              counterServices: [
                  {
                      total_sh_ges: data.counterServices[0] ? data.counterServices[0].total_sh_ges : 0,
                      total_sp_ges: data.counterServices[0] ? data.counterServices[0].total_sp_ges : 0
                  }
              ],
              counterYear : data.counterYear ? data.counterYear : [],
              selectedYear : data.selectedYear ? data.selectedYear : []
          }
        : {
                counterServices: [
                    {
                        total_sh_ges: 0,
                        total_sp_ges: 0
                    }
                ],
                counterYear: [],
                selectedYear: []
          };

    const colors = ['#1F77B4', '#FF7F0E'];

    const subtitles = ["Hospitalar", "Ambulatorial"];

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                colors,
                subtitles,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
